import { buildEntityMap } from "./utils/build-entity-map.js";
export class WdClassSurroundings {
    startClassId;
    parentsIds;
    subjectOfIds;
    valueOfIds;
    classesMap;
    propertiesMap;
    constructor(response) {
        this.startClassId = response.results.startClassId;
        this.parentsIds = response.results.parentsIds;
        this.subjectOfIds = response.results.subjectOfIds;
        this.valueOfIds = response.results.valueOfIds;
        this.classesMap = buildEntityMap(response.results.classes);
        this.propertiesMap = buildEntityMap(response.results.properties);
    }
}
//# sourceMappingURL=get-class-surroundings.js.map